import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';

import { useHistory } from "react-router-dom";
import moment from 'moment';

import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import api from '../../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import { useLocation } from 'react-router-dom';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    whiteUnderline: {
        '&:before': {
            borderBottom: '1px solid white',
        },
        '&:after': {
            borderBottom: '2px solid white',
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid white',
        },
    },
}));



export default function CadastroEntradaEstoque() {

    const [loading, setLoading] = useState(true);

    const darkMode = Cookies.get('darkMode') === 'true';

    const classes = useStyles();
    const history = useHistory();
    const [descricao, setDescricao] = useState('');


    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const idPreCotacao = queryParams.get("id-pre-cotacao"); // retorna string ou null se não existir



    const [ordemCompraSelecionada, setOrdemCompraSelecionada] = useState(null);
    const [ordens, setOrdens] = useState(null);

    const [compraSelecionada, setCompraSelecionada] = useState(null);


    const [executores, setExecutores] = useState(null);

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            console.log("Id da pre cotaca é: " + idPreCotacao);

            if (idPreCotacao) {
                setOrdens([]);

                await api.get("v1/protected/ordensdecompras/ordemdecompra/precotacao/listarporid/" + idPreCotacao, {
                    headers: headers
                }).then(function (response) {




                    api.get("v1/protected/ordensdecompras/ordemdecompra/listarporidsimples/" + response.data.id_ordem_compra, {
                        headers: headers
                    }).then(function (response2) {

                        console.log(JSON.stringify(response2.data))
                        setOrdemCompraSelecionada(response2.data);

                        setCompraSelecionada(response.data);

                        setLoading(false);


                    });


                });


            } else {
                console.log("buscando ordens autorizadas nao recebidas")
                await api.get("/v1/protected/ordensdecompras/ordemdecompra/listarordensautorizadasnaorecebidas", {
                    headers: headers
                }).then(function (response) {
                    console.log("Ordens sem entradas listadas");
                    setOrdens(response.data)

                    console.log(JSON.stringify(response.data));

                    setLoading(false);


                });
            }


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar Informações: " + _err)

        }

    }



    useEffect(() => {
        listarInformacoes();


    }, []);


    function returnDescricaoFornecedor(fornecedor) {
        var texto = "Fornecedor_ID: " + fornecedor.id_fornecedor + "\nCPF/CNPJ: " + (fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj) +
            "\nNome/Nome Fantasia: " + (fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) : fornecedor.nome_fantasia);

        return texto;
    }


    function returnDescricaoOrdem(ordem) {
        var texto = "Ordem_ID: " + ordem.id_ordem_compra + "\nDescrição da Ordem: " + ordem.descricao;
        return texto;
    }


    function returnDescricaoExecutor(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
        return texto;
    }

    function returnDescricaoCompra(compra) {
        var texto = "Compra_ID: " + compra.id_pre_cotacao + "\nFornecedor: " + compra.nome_fornecedor_amigavel + "\nValor: " + (compra.valor_total + compra.valor_frete);
        return texto;
    }

    async function salvar() {





        if (!ordemCompraSelecionada.id_ordem_compra) {
            alert("Informe a Ordem de Compra!");
            return;
        } else {


        }


        if (!compraSelecionada.id_pre_cotacao) {
            alert("Informe a Compra!");
            return;
        } else {


        }


        try {

            console.log("cadastrar chamado");
            const cadastro = {


                descricao: descricao,
                usuario_criador: { id_usuario: Cookies.get("id_usuario") },
                usuario_executor: { id_usuario: Cookies.get("id_usuario") },
                id_ordem_compra: ordemCompraSelecionada.id_ordem_compra,
                pre_cotacao: { id_pre_cotacao: compraSelecionada.id_pre_cotacao },



            }

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/almoxarifado/entradaestoque/cadastrarentradaestoque', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Nova Operação Entrada de Estoque Cadastrada")
                history.push({
                    pathname: "/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/" + cadastro_salvo.id_entrada_estoque,
                })
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }


    function handleSetOrdemCompra(ordem) {
        setOrdemCompraSelecionada(ordem);
    }




    function handleSetCompra(compra) {
        setCompraSelecionada(compra);
    }




    return (
        <div style={{ backgroundColor: darkMode ? '#121212' : 'white', minHeight: '100vh', color: darkMode ? '#fff' : 'inherit' }}>

            <NavegadorGestao
                Almoxarifado={true}
                OpEntrada={true}
                corFundo={darkMode ? '#1e1e1e' : 'white'} travado={true} corTexto={darkMode ? '#fff' : 'black'}
            />
            <Container style={{ paddingTop: 5 }} >
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :
                    <React.Fragment >
                        <Grid container spacing={2}   >



                            <Grid
                                style={{ paddingTop: 5 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={6}
                                    style={{ marginTop: 5 }}
                                >
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                    >

                                        <Autocomplete
                                            id="select-ordem"
                                            options={idPreCotacao ? [] : ordens}
                                            freeSolo
                                            disableCloseOnSelect
                                            getOptionLabel={(ordem) => returnDescricaoOrdem(ordem).replace(/<br \/>/g, '\n')}
                                            value={ordemCompraSelecionada}
                                            disabled={idPreCotacao ? true : false}
                                            onChange={(e, v) => handleSetOrdemCompra(v)}
                                            filterOptions={(options, { inputValue }) => {
                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                return options.filter((cotacao) => {
                                                    const cotacaoText = returnDescricaoOrdem(cotacao).toLowerCase();
                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: { color: darkMode ? 'white' : 'black' },
                                                        classes: {
                                                            underline: classes.whiteUnderline,
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        ...params.InputLabelProps,
                                                        style: { color: darkMode ? 'white' : 'black' },
                                                    }}
                                                    label=" Ordem de Compra " multiline minRows={3} />
                                            )}
                                            renderOption={(option) => (
                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoOrdem(option) }} />
                                            )}
                                        />
                                    </Grid>
                                </Grid>


                                {
                                    ordemCompraSelecionada &&
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={6}
                                        style={{ marginTop: 5 }}
                                    >
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                        >

                                            <Autocomplete
                                                id="select-compra"
                                                options={
                                                    idPreCotacao ? [] :
                                                        ordemCompraSelecionada.pre_cotacoes.filter((cotacao) =>
                                                            cotacao.itens_pre_cotacao.some((item) => item.selecionado === 1)
                                                        )
                                                }
                                                disabled={idPreCotacao ? true : false}
                                                disableCloseOnSelect
                                                getOptionLabel={(compra) => returnDescricaoCompra(compra).replace(/<br \/>/g, '\n')}
                                                value={compraSelecionada}
                                                onChange={(e, v) => handleSetCompra(v)}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((cotacao) => {
                                                        const cotacaoText = returnDescricaoCompra(cotacao).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params}

                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: { color: darkMode ? 'white' : 'black' },
                                                            classes: {
                                                                underline: classes.whiteUnderline,
                                                            },
                                                        }}
                                                        InputLabelProps={{
                                                            ...params.InputLabelProps,
                                                            style: { color: darkMode ? 'white' : 'black' },
                                                        }}
                                                        label=" Compra " multiline minRows={3} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoCompra(option) }} />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>

                                }


                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    variant="standard"
                                    name="descricao"
                                    label="Descrição"
                                    id="descricao"
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    InputProps={{
                                        style: { color: darkMode ? 'white' : 'black' },
                                        classes: {
                                            underline: classes.whiteUnderline,
                                        },
                                    }}
                                    InputLabelProps={{
                                        style: { color: darkMode ? 'white' : 'black' },
                                    }}
                                />
                            </Grid>




                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                item xs={10}
                            >
                                <Button style={{ margin: 5 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={salvar}
                                > Salvar  </Button>
                            </Grid>

                        </Grid>


                    </React.Fragment>
                }

            </Container>

        </div >
    );
}


